export const getSeanetLocaleInfo = (locale) => {
    switch (locale) {
        case "en_US":
            return {
                name: "English",
                allMoviesGenreTitle: "All Movies"
            }
        case "de_DE":
            return {
                name: "Deutsch",
                allMoviesGenreTitle: "Alle Filme"
            }
        case "es_ES":
            return {
                name: "Español",
                allMoviesGenreTitle: "Todas las películas"
            }
        case "es_MX":
            return {
                name: "Español de México",
                allMoviesGenreTitle: "Todas las películas"
            }
        default:
            return {
                name: locale,
                allMoviesGenreTitle: "All Movies"
            }
    }
}